export interface SkeletonRowsProps {
  count?: number;
  showSecondary?: boolean;
}

/** Loading placeholder for list screens. Never a full-screen spinner. */
export function SkeletonRows({ count = 4, showSecondary = true }: SkeletonRowsProps) {
  return (
    <div aria-busy="true" aria-label="Loading" className="fw-rows">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="fw-skeleton-row">
          <span className="fw-skeleton-bar" style={{ width: `${68 - (i % 3) * 12}%` }} />
          {showSecondary && <span className="fw-skeleton-bar fw-skeleton-bar--secondary" />}
        </div>
      ))}
    </div>
  );
}
